
(function (root, factory) {
    'use strict';
    var _export;

    if (typeof module !== "undefined") {
        // CommonJS
        factory(module, require('underscore'), require('dibs-backbone'));
        _export = module.exports;
    } else {
        // browser globals
        var _m = {};

        factory(_m, root._, root.Backbone);
        _export = _m.exports;
    }

    root.bunsen = root.bunsen || {};
    root.bunsen.currency = _export;
}(typeof window === 'undefined' ? global : window, function (module, _, Backbone) {
    'use strict';

    var allCurrencies;
    var dictionary = {};
    var Currency = function (name, enumValue, symbol) {
        this.name = name;
        this.enumValue = enumValue;
        this.symbol = symbol;
    };

    /**
     * For the given Currency Name, Currency ENUM or Currency Symbol
     * try to pull up the canonical Currency instance
     * If a Currency instance is passed in, it's returned back
     * @param {String|Currency} lookupBy
     * @returns {Currency|undefined}
     */
    var lookupCurrency = function (lookupBy) {
        if (lookupBy instanceof Currency) {
            return lookupBy;
        }
        return dictionary[('' + lookupBy).toLowerCase()];
    };

    /**
     * Round the given number to the given precision
     * @param {number} what
     * @param {number} precision
     * @returns {number}
     */
    function round(what, precision) {
        precision = parseInt(precision, 10) || 0;
        return Math.round((parseFloat(what) * Math.pow(10, precision))) / Math.pow(10, precision);
    }

    function buildObj(key, value, filter) {
        var lookup = {};
        _.each(allCurrencies, function (C) {
            if (!filter || filter(C)) {
                lookup[C[key]] = C[value];
            }
        });
        return lookup;
    }

    /**
     * With the given conversion rate(s), and with the given
     * precision, convert the given amount from this currency to
     * the given currency
     * @param {String|Currency} fromAmount
     * @param {String|Currency} toCurrency
     * @param {CurrencyConversionRate|Backbone.Collection} rates
     * @param {number} precision
     * @returns {number|undefined}
     */
    Currency.prototype.convert = function (fromAmount, toCurrency, rates, precision) {
        var rate, self;
        if (!(toCurrency instanceof Currency)) {
            toCurrency = lookupCurrency(toCurrency);
        }
        if (!toCurrency) {
            return void 0;
        }
        self = this;
        if (precision === void 0) {
            precision = 2;
        }
        if (self === toCurrency) {
            return round(fromAmount, precision);
        }
        if (rates instanceof Backbone.Collection) {
            rates.each(function (oneRate) {
                if (oneRate.canConvert(self, toCurrency)) {
                    rate = oneRate;
                }
            });
        } else if (typeof rates.canConvert === 'function' && rates.canConvert(self, toCurrency)) {
            rate = rates;
        }
        if (!rate) {
            return void 0;
        }
        return rate.convert(fromAmount, self, toCurrency, precision);
    };

    allCurrencies = [
        new Currency('US Dollar', 'USD', '$'),
        new Currency('Canadian Dollar', 'CAD', 'C $'),
        new Currency('British Pound', 'GBP', '&pound;'),
        new Currency('Euro', 'EUR', '&euro;')
    ];

    /**
     * Adding canonical instances to the dictionary
     */
    _.each(allCurrencies, function (C) {
        dictionary[('' + C.name).toLowerCase()] = C;
        dictionary[('' + C.enumValue).toLowerCase()] = C;
        dictionary[('' + C.symbol).toLowerCase()] = C;
    });

    lookupCurrency.getSymbol = function (c) {
        var currencyObj = lookupCurrency(c);
        if (currencyObj) {
            return currencyObj.symbol;
        }
    };

    lookupCurrency.buildObj = buildObj;
    module.exports = lookupCurrency;
}));



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/libraries/currency.js
// module id = 313
// module chunks = 62